import React from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { Accordion, AccordionDetails, AccordionSummary, Typography, withStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { RenderTextField as TextField } from '../../../components/RenderTextField';
import { RenderMarkupEditor as MarkupEditor } from '../../../components/MarkupEditor';
import { validateForm } from '../../../utils';
import styles from './WebsiteEditStepStyles';
import { WebsitesEditStepActions } from './WebsitesEditStepActions';
import LeavePrompt from '../../../components/LeavePrompt';
import TemplatesSelectionDialog from '../../../components/TemplatesSelectionDialog';

const DECLARATION_TEMPLATE = 'declarationTemplate';

const validate = values => {
  const requiredFields = [];
  return validateForm(values, requiredFields);
};

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      templateName: props.initialValues.declarationTemplate.name,
    };
  }

  changeTemplateName = (changedTemplateName) => {
    changedTemplateName.split(this.props.initialValues.websiteName).join('');

    this.setState({
      templateName: `${this.props.initialValues.websiteName} - ${changedTemplateName}`,
    });
  };

  getFormFieldName(propertyName) {
    return `${DECLARATION_TEMPLATE}.${propertyName}`;
  }

  changeTemplate(args, formState, tools) {
    const template = args[0];
    for (const property in template) {
      tools.changeValue(formState, this.getFormFieldName(property), () => template[property]);
    }
  }

  render() {
    const { classes, initialValues, onSubmit, id } = this.props;

    return (
      <div className={classes.container}>
        <LeavePrompt dirty={this.props.dirty && !this.props.submitting} message="You have unsaved data. Do you want to leave anyway?"/>
        <FinalForm
          onSubmit={(data) => {
            onSubmit(data);
          }}
          initialValues={initialValues}
          validate={validate}
          mutators={{ changeTemplate: this.changeTemplate.bind(this) }}
          render={({ handleSubmit, form: finalForm, invalid }) => {
            return (
              <form onSubmit={handleSubmit}>
                <WebsitesEditStepActions
                  id={id}
                  title="Cookie Policy"
                  disabled={invalid}
                />
                <div className={classes.wrapper}>
                  <div>
                    <Typography className={classes.heading}>Policy</Typography>
                    <div className={classes.template}>
                      <Typography variant="caption">Design</Typography>
                      <Typography variant="body1">{this.state.templateName}</Typography>
                      <TemplatesSelectionDialog style={classes.changeTemplateButton}
                        callbackFromParent={this.changeTemplateName}
                        website={id}
                        templatesType="declaration_templates"
                        formName="declaration"
                        selectedTemplates={{ declarationTemplate: initialValues.declarationTemplate }}
                        onSubmit={finalForm.mutators.changeTemplate}
                      />
                    </div>
                  </div>
                  <div role="panel">
                    <Accordion elevation={2} defaultExpanded>
                      <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography>Translations</Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.extendedDetails}>
                        <Field component={TextField}
                          className={classes.input}
                          name="cookieConsentText.cookiesOverview"
                          label="Cookie Policy header"
                          margin="normal"/>
                        <Field component={TextField}
                          className={classes.textField}
                          multiline
                          maxRows={10}
                          name="cookieConsentText.cookieDeclarationText"
                          label="Cookie Policy text"
                          margin="normal"/>
                        <Field component={TextField}
                          className={classes.input}
                          name="cookieConsentText.domainListExplanation"
                          label="Information about domains text"
                          margin="normal"/>
                        <Field component={TextField}
                          className={classes.input}
                          name="cookieConsentText.noScanPerformed"
                          label="No scan performed text"
                          margin="normal"/>
                        <Field component={TextField}
                          className={classes.input}
                          name="cookieConsentText.lastUpdated"
                          label="Last updated text"
                          margin="normal"/>
                        <Field component={TextField}
                          className={classes.input}
                          name="cookieConsentText.serviceRole"
                          label="Service role"
                          margin="normal"/>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                  <div role="panel">
                    <Accordion elevation={2}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography> Advanced Settings </Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.extendedDetails}>
                        <Typography className={classes.extendedDetailsDescription}>
                          Customize the way your policy looks and functions
                        </Typography>
                        <Field component={MarkupEditor}
                          className={classes.textField}
                          name="declarationTemplate.html"
                          label="HTML definition of policy"
                          mode="html"/>
                        <Field component={MarkupEditor}
                          className={classes.textField}
                          name="declarationTemplate.css"
                          label="Cascading Style Sheets (CSS)"
                          mode="css"/>
                        <Field component={MarkupEditor}
                          className={classes.textField}
                          name="declarationTemplate.js"
                          label="Javascript functions"
                          mode="javascript"/>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </form>
            );
          }}
        />
      </div>
    );
  }
}

const StyledForm = withStyles(styles)(Form);
export default StyledForm;

